import { buildModuleApi } from "../../../../../_CORE/API/_ApiUtil/_buildModuleApi";

const EXCLUDE_STANDARD = [
    "LIST", "CREATE", "UPDATE", "REMOVE", "DETAIL",
    "ARCHIVE", "RESTORE", "ARCHIVED", "BULK_CREATE", "BULK_ARCHIVE",
    "BULK_RESTORE", "BULK_REMOVE_REQUEST", "BULK_REMOVE_CONFIRM",
];

const PERSONAL_VAULT = buildModuleApi({
    prefix: "PERSONAL_VAULT",
    uri: "personal-vault",
    withExtra: false,
    exclude: EXCLUDE_STANDARD,
    extraActions: {
        GROUP_LIST: { suffix: "/groups" },
        GROUP_CREATE: { suffix: "/groups" },
        GROUP_DETAIL: { suffix: "/groups/:id" },
        GROUP_UPDATE: { suffix: "/groups" },
        GROUP_REMOVE: { suffix: "/groups" },
        GROUP_VERIFY_PIN: { suffix: "/groups/:id/verify-pin" },
        GROUP_ARCHIVE_LIST: { suffix: "/groups/archived/list" },
        GROUP_ARCHIVE: { suffix: "/groups/:id/archive" },
        GROUP_RESTORE: { suffix: "/groups/:id/restore" },
        ENTRY_ARCHIVE_LIST: { suffix: "/entries/archived/list" },
        ENTRY_CREATE: { suffix: "/entries" },
        ENTRY_UPDATE: { suffix: "/entries" },
        ENTRY_REMOVE: { suffix: "/entries" },
        ENTRY_REVEAL: { suffix: "/entries/:id/reveal" },
        ENTRY_ARCHIVE: { suffix: "/entries/:id/archive" },
        ENTRY_RESTORE: { suffix: "/entries/:id/restore" },
        RECOVERY_CODES_IMPORT: { suffix: "/entries/:id/recovery-codes/import" },
        RECOVERY_CODE_REVEAL: { suffix: "/recovery-codes/:id/reveal" },
        RECOVERY_CODE_CONSUME: { suffix: "/recovery-codes/:id/consume" },
        RECOVERY_CODE_ARCHIVE_LIST: { suffix: "/recovery-codes/archived/list" },
        RECOVERY_CODE_ARCHIVE: { suffix: "/recovery-codes/:id/archive" },
        RECOVERY_CODE_RESTORE: { suffix: "/recovery-codes/:id/restore" },
        RECOVERY_CODE_REMOVE: { suffix: "/recovery-codes" },
        FILE_ARCHIVE_LIST: { suffix: "/files/archived/list" },
        FILE_UPLOAD: { suffix: "/files/upload" },
        FILE_DOWNLOAD: { suffix: "/files/:id/download" },
        FILE_ARCHIVE: { suffix: "/files/:id/archive" },
        FILE_RESTORE: { suffix: "/files/:id/restore" },
        FILE_REMOVE: { suffix: "/files" },
    },
});

export const PERSONAL_VAULT_API = PERSONAL_VAULT.API;
export const PERSONAL_VAULT_CONSTANTS = PERSONAL_VAULT.CONSTANTS;
export const PERSONAL_VAULT_ENDPOINTS = PERSONAL_VAULT.ENDPOINTS;
